import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPropertyVehicleDetailResponseDTO,
	type ClientPropertyVehicleEditRequestDTO,
	patchPropertyVehicleIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPropertyVehicleMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientPropertyVehicleDetailResponseDTO,
		Error,
		Partial<ClientPropertyVehicleEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPropertyVehicleIdV2(requestContract, id),
		),
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.propertyList() });
			queryClient.setQueryData(PortfolioKeys.propertyDetail(id), data);
		},
	});
};
